import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { XCircle, ArrowLeft, RefreshCcw } from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const RejectedList = ({ companies, onBack, onRestore }) => {
  const [restoringId, setRestoringId] = useState(null);
  const rejectedCompanies = companies
    .filter(c => c.status === 'REJECTED')
    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

  const handleRestore = async (companyId) => {
    try {
      setRestoringId(companyId);
      await axios.post(`${API}/companies/${companyId}/restore`);
      toast.success('Firma erfolgreich wiederhergestellt!');
      if (onRestore) {
        onRestore();
      }
    } catch (error) {
      console.error('Restore failed:', error);
      toast.error(error.response?.data?.detail || 'Fehler beim Wiederherstellen');
    } finally {
      setRestoringId(null);
    }
  };

  return (
    <div>
      <Card className="mb-6 border-red-200 bg-gradient-to-r from-red-50 to-pink-50">
        <CardHeader>
          <div className="flex items-center gap-3">
            <Button variant="outline" size="sm" onClick={onBack}>
              <ArrowLeft className="h-4 w-4 mr-2" />
              Zurück
            </Button>
            <CardTitle className="flex items-center gap-2">
              <XCircle className="h-6 w-6 text-red-600" />
              Abgelehnte Unternehmen ({rejectedCompanies.length})
            </CardTitle>
          </div>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            {rejectedCompanies.length === 0 ? (
              <div className="text-center py-8 text-slate-500">
                Keine abgelehnten Unternehmen
              </div>
            ) : (
              rejectedCompanies.map((company) => (
                <Card key={company.id} className="border-red-200">
                  <CardContent className="pt-6">
                    <div className="flex justify-between items-start mb-2">
                      <h3 className="font-bold text-lg text-slate-900">{company.title}</h3>
                      <Button
                        size="sm"
                        variant="outline"
                        onClick={() => handleRestore(company.id)}
                        disabled={restoringId === company.id}
                        className="ml-2"
                      >
                        <RefreshCcw className={`h-4 w-4 mr-2 ${restoringId === company.id ? 'animate-spin' : ''}`} />
                        Wiederherstellen
                      </Button>
                    </div>
                    <div className="space-y-1 text-sm">
                      <a 
                        href={company.website?.startsWith('http') ? company.website : `https://${company.website}`} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="text-blue-600 hover:underline block"
                      >
                        🌐 {company.website}
                      </a>
                      {company.address && (
                        <div className="text-slate-600">📍 {company.address}</div>
                      )}
                      {company.ai_analysis && (
                        <div className="mt-2 p-2 bg-red-50 rounded text-red-700">
                          {company.ai_analysis}
                        </div>
                      )}
                    </div>
                  </CardContent>
                </Card>
              ))
            )}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default RejectedList;
